<template>
<div class="email-wrap">
    <div class="email-inner" v-if="wayType==='email'">
        <email-input @changeErrorTxt="changeErrorTxtHandle" @changeEmail="changeEmailHandle" @btnSure="next" />
        <error-tip ref="errorTip" :txt="errorTxt"/>
        <button-wrap :has="actBtn" :cover="cover" :txt="$t($loginLangPrefix('userSign.next'))" @btnSure="next" />
    </div>
    <div class="memail-inner" v-if="wayType==='m-email'">
        <title-txt :txt="`${$t($loginLangPrefix('userSign.logReg'))}`" />
        <desc-txt :txt="$t($loginLangPrefix('userSign.phEmailTips'))" />
        <email-input mb="mb" @changeErrorTxt="changeErrorTxtHandle" @changeEmail="changeEmailHandle" />
        <error-tip ref="errorTip" :txt="errorTxt" mb="mb"/>
        <button-wrap mb="mb" :has="actBtn" :cover="cover" :txt="$t($loginLangPrefix('userSign.next'))" @btnSure="next" />
    </div>
</div>
</template>
<script>

import error from '../common/error';
import api from '../js/api';

import emailInput from '../common/emailInput';
import desc from '../common/desc';
import title from '../common/title';
import button from '../common/button';

export default {
    name: 'emailparent',
    props: {
        wayType: { type: String, default: '' }
    },
    data() {
        return {
            email: '',
            errorTxt: '',
            cover: false
        };
    },
    computed: {
        actBtn() {
            return !!this.email && !this.errorTxt;
        }
    },
    components: {
        'error-tip': error,
        'email-input': emailInput,
        'button-wrap': button,
        'desc-txt': desc,
        'title-txt': title
    },
    methods: {
        changeErrorTxtHandle(txt) {
            this.errorTxt = txt;
        },
        changeEmailHandle(email) {
            this.email = email;
        },
        next() {
            if (this.email && !this.errorTxt && !this.cover) {
                this.cover = true;
                api.userIsExist(`${this.email}`).then((data) => {
                    // 12007 12006 12005账号存在
                    if (data.ret === '12007' || data.ret === '12006' || data.ret === '12005') {
                        this.$emit('inputEmail', 'login', this.email);
                    } else {
                        this.$emit('inputEmail', 'reg', this.email);
                    }
                    this.cover = false;
                }).catch((response) => {
                    this.cover = false;
                    if (response.errorMessageTMXTip) {
                        return;
                    }
                    this.errorTxt = this.$t(this.$loginLangPrefix('userSign.sysError'));
                });
            }
        }
    },

    mounted() {
    },

    beforeDestroy() {
    }
};
</script>
<style lang="scss" scoped>
@function rem($n) {
    @return ($n*1rem / 50);
}
.email-wrap {
    input, div {
        -webkit-tap-highlight-color: rgba(0,0,0,0);
        outline: none;
        border: 0;
    }
    position: relative;
    width: 100%;
    .memail-inner {
        position: relative;
        width: 100%;
    }
}
</style>
